import { createContext, Fragment, useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import useMediaQuery from './hook/useMediaQuery'
import ScrollToTop from 'components/Common/ScrollToTop'
import NotFound from 'components/NotFound/NotFound'
import Main from 'screens/Main'
import { Bounce, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import About from 'screens/About'
import PortfolioDetail from 'screens/Main/PortfolioDetail'
import Contact from 'screens/Contact'
import Experience from 'screens/Experience'
import Request from 'screens/Request'
import News from 'screens/News'
import MainMo from 'screens/MainMo'

interface IGlobalContext {
  isTablet: boolean
  isMobile: boolean
}

export const GlobalContext = createContext<IGlobalContext>({
  isTablet: false,
  isMobile: false,
})

const App = () => {
  const isTabletByQuery = useMediaQuery('(max-width: 768px)')
  const isMobileByQuery = useMediaQuery('(max-width: 576px)')
  const [isTablet, setIsTablet] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setScreenSize();
  }, []);

  useEffect(() => {
    setIsTablet(isTabletByQuery)
  }, [isTabletByQuery])

  useEffect(() => {
    setIsMobile(isMobileByQuery)
  }, [isMobileByQuery])


  useEffect(() => {
    const handleResize = () => {
      setScreenSize()
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const setScreenSize = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  return (
    <Fragment>
      <GlobalContext.Provider value={{ isTablet, isMobile }}>
        <div className="relative bg-[#F4F5F8] App">
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer
              position="top-center"
              autoClose={2500}
              limit={6}
              newestOnTop={false}
              closeOnClick={true}
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              transition={Bounce}
            />
            <Routes>
              <Route path="/" element={isTablet ? <MainMo /> : <Main />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/request" element={<Request />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/portfolioDetail" element={<PortfolioDetail />} />
              <Route path="/news" element={<News />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </div>
      </GlobalContext.Provider>
    </Fragment>
  )
}

export default App
